"use client";

import { useEffect, useState, type ComponentPropsWithoutRef } from "react";
import Image from "next/image";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

type LearnMoreIconIllustrationProps = Omit<
  ComponentPropsWithoutRef<typeof Image>,
  "src" | "alt"
> & {
  alt?: string;
};

function useLearnMoreIconSrc() {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return "/assets/learn-more-icon.svg";
  }

  return resolvedTheme === "light"
    ? "/assets/light/learn-more-icon.svg"
    : "/assets/learn-more-icon.svg";
}

export function LearnMoreIconIllustration({
  className,
  alt = "",
  width = 32,
  height = 32,
  ...props
}: LearnMoreIconIllustrationProps) {
  const src = useLearnMoreIconSrc();

  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={cn("size-full", className)}
      {...props}
    />
  );
}
